//* react
import React from 'react';

//* system
import CreateSingleUser from './CreateSingleUser';
import { ChatUserModel } from 'types/chat-users/chat-user';
import { useNavigate } from 'react-router-dom';
import { useCurrentChatView } from 'hooks/useCurrentChatView';
// import AppSidebarContent from 'layout/MainLayout/AppSidebarContent';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import useLocalization from 'hooks/useLocalization';

interface CreateUserSidebarProps {
  open: boolean;
  onClose: () => void;
  /** מילוי טלפון מהחיפוש ברשימת השיחות */
  initialPhone?: string;
  /** When set, runs instead of navigating to the new chat (e.g. refresh contacts list). */
  afterCreate?: (user: ChatUserModel) => void;
}

const CreateUserSidebar: React.FC<CreateUserSidebarProps> = ({ open, onClose, afterCreate, initialPhone }) => {
  const { currentLocale } = useLocalization();
  const navigate = useNavigate();
  const currentView = useCurrentChatView();

  const [loading, setLoading] = React.useState(false);

  const formRef = React.useRef({
    submit: () => {},
  });

  return (
    // <AppSidebarContent id="create-user-sidebar">
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ textAlign: 'start', px: 3, pt: 2, pb: 1 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
          <Stack direction="row" alignItems="center" spacing={1.5} sx={{ minWidth: 0, flex: 1 }}>
            <PersonAddOutlinedIcon color="primary" sx={{ fontSize: 28, flexShrink: 0 }} aria-hidden />
            <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
              {currentLocale.chat.createUsers.mainTitle}
            </Typography>
          </Stack>
          <IconButton onClick={onClose} aria-label="Close dialog" size="small" sx={{ flexShrink: 0 }}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent
        sx={{
          pt: 2,
          pb: 2,
          px: 3,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <CreateSingleUser
          initialPhone={initialPhone}
          onUserCreated={(user) => {
            setTimeout(() => {
              onClose();
              if (afterCreate) {
                afterCreate(user);
              } else {
                navigate(currentView.path + '/' + user.UserDisplayPhoneNumber);
              }
            }, 2000); // המתן 2 שניות לפני סגירה
          }}
          onLoadingChange={setLoading}
          outerSubmit={true}
          ref={formRef}
        />
      </DialogContent>
    </Dialog>

    // </AppSidebarContent>
  );
};

export default CreateUserSidebar;
